import { IntegrationsStore } from '@gamiphy/loyalty-station-desktop/store/integrations';
import { Pages, Tabs, UiStore } from '@gamiphy/loyalty-station-desktop/store/ui';
import { UserStore } from '@gamiphy/loyalty-station-desktop/store/user';
import { Trans, useTranslation } from '@gamiphy/react-i18n';
import { formatNumber } from '@gamiphy/utils/number';
import {
  Button, Card, CardContent, Grid,
} from '@mui/material';
import { observer } from 'mobx-react';
import React from 'react';
import { UnavowedPopup } from '../../popups/unavowed';

const RedeemCard: React.FC = observer(() => {
  const [showPopup, setShowPopup] = React.useState<boolean>(false);
  const { t } = useTranslation();

  const handleClick = React.useCallback(() => {
    if (UserStore.isRealUser && UserStore.user?.points.gems) {
      UiStore.setTab(Tabs.Redeem);
      UiStore.setPage(Pages.home);
    } else if (UserStore.isRealUser) {
      UiStore.setPage(Pages.home);
      UiStore.setTab(Tabs.Missions);
    } else {
      setShowPopup(true);
    }
    void IntegrationsStore.trackGTMEvent({ category: 'RedeemFooter', action: 'redeemClicked' });
  }, [UserStore.isRealUser, UserStore.user?.points.gems]);

  const showButton = React.useMemo(
    () => (UserStore.user?.points.gems &&
    UiStore.currentPage === Pages.home &&
     UiStore.currentTab !== Tabs.Redeem) ||
      !UserStore.user?.points.gems,
    [UserStore.user?.points.gems,
      UiStore.currentPage,
      UiStore.currentTab],
  );

  const btnText = React.useMemo(() => {
    switch (UserStore.user?.points.gems) {
      case 0:
        return (
          <Trans
            i18nKey="welcomePoints.getWelcomePoints"
            defaults="Get {{gems, gems}}"
            values={{}}
          />
        );
      default:
        return (
          <Trans
            i18nKey="shared.redeem"
            defaults="Redeem"
            values={{}}
          />
        );
    }
  }, [UserStore.user?.points.gems]);

  return (
    <Card sx={{ borderRadius: 0 }}>
      <CardContent sx={{ py: '1rem !important' }}>
        <Grid container justifyContent="space-between" alignItems="center" wrap="nowrap">
          <Grid
            container
            alignItems="center"
            justifyContent="flex-start"
            sx={{
              fontSize: '1.3rem', fontWeight: 500, textTransform: 'capitalize', mr: 0.5,
            }}
          >
            <Grid sx={{ mr: 1 }}>
              <Trans
                i18nKey="redeem.slider.points"
                defaults="{{, gems}}"
                values={{}}
              />
            </Grid>
            <Grid sx={{ fontWeight: 'bold' }}>
              {formatNumber(UserStore.user?.points.gems ?? 0, { notation: 'standard' })}
            </Grid>
          </Grid>
          {showButton && (
            <Grid>
              <Button
                sx={{
                  px: 1,
                  fontSize: '1.2rem',
                  width: '11rem',
                }}
                variant="contained"
                color="primary"
                onClick={handleClick}
              >
                {btnText}
              </Button>
            </Grid>
          )}
        </Grid>
        <UnavowedPopup
          open={showPopup}
          onClose={() => setShowPopup(false)}
          title={t('unavowedPopup.rewardTitle', 'Sign up now to redeem your coupon for exclusive discounts!')}
        />
      </CardContent>
    </Card>
  );
});

export default RedeemCard;
